import { render, staticRenderFns } from "./CreateMultipleOrgan.vue?vue&type=template&id=7523fbf4"
import script from "./CreateMultipleOrgan.vue?vue&type=script&lang=js"
export * from "./CreateMultipleOrgan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports